module.exports = __webpack_public_path__ + "static/media/orderDetail_backgroundImg.56d2e199.png";